import { Component } from '@angular/core';
import { AppInfoService } from '../../../shared/services/general';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent {

    constructor(public appInfo: AppInfoService) {

    }

}
